import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core"
import { Router } from "@angular/router"
import { LexTranslateService } from "@app/core/services/lex-translate.service"

@Component({
  selector: "seb-modal-warning",
  templateUrl: "./modal-warning.component.html",
  styleUrls: ["./modal-warning.component.css"],
})
export class ModalWarningComponent implements OnInit {
  @Input() title: string
  @Input() warning: string
  @Input() question: string
  @Input() customId: string = "exampleModal"
  @Input() cancelButtonText: string
  @Input() confirmButtonText: string
  @Input() singleButton: boolean = false

  @Output() onConfirm = new EventEmitter()
  @Output() onCancel = new EventEmitter()

  constructor(
    private router: Router,
    public lextranslate: LexTranslateService
  ) {}

  async ngOnInit() {
    await this.lextranslate.loadTranslationsInFunctionOfTenant()

    this.cancelButtonText =
      this.cancelButtonText ??
      this.lextranslate.i18n["959fd220-ec97-46fd-8218-cd1217e026e4"]
    this.confirmButtonText =
      this.confirmButtonText ??
      this.lextranslate.i18n["dcf43eb9-086b-4945-84eb-8ea69cdcdfc8"]
  }

  get customIdLabel() {
    return `${this.customId}Label`
  }

  redirectTo(route: string) {
    this.router.navigate([route])
  }

  onClickButton() {
    this.onConfirm.emit()
  }

  onCancelButton() {
    this.onCancel.emit()
  }
}
